import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { BoldHeader2Text, Button, Icon, IconSize, IconType, RotatingIcon } from 'ui-toolkit';
import { IFetchStatus } from 'types/rest/IFetchStatus';
import OrderProgressDropdown from './OrderProgressDropdown';
import { eInternalOrderStatus } from '../../../../ui-toolkit/enums/eInternalOrderStatus';
import { IOrderDetailsData } from '../../../../ui-toolkit/orders/interfaces/IOrderDetailsData';

const CancelledStatusText = styled(BoldHeader2Text)`
  color: ${(props) => props.theme.colors.error};
`;

export interface IChangableStatusTextProps {
  children?: ReactNode;
  canCancelOrder: boolean;
  order: IOrderDetailsData;
  resetOrder: () => void;
  fetchStatus: IFetchStatus;
}

export const ChangableStatusText: React.FC<IChangableStatusTextProps> = ({
  children,
  canCancelOrder,
  order,
  resetOrder,
  fetchStatus,
}) => {
  const { status } = order.orderInformation;
  return (
    <>
      {status === eInternalOrderStatus.complete ? <BoldHeader2Text>Complete</BoldHeader2Text> : null}
      {status !== eInternalOrderStatus.cancelled ? (
        <OrderProgressDropdown disableCancelButton={!canCancelOrder} order={order}>
          {children}
        </OrderProgressDropdown>
      ) : null}
      {fetchStatus.fetching && <RotatingIcon type={IconType.Loading} size={IconSize.Small} />}
      {fetchStatus.success && <Icon type={IconType.Check} size={IconSize.Small} />}
      {status === eInternalOrderStatus.cancelled && (
        <>
          <CancelledStatusText>Cancelled</CancelledStatusText>
          <Button intent={'secondary'} onClick={resetOrder}>
            Re-open order
          </Button>
        </>
      )}
    </>
  );
};
